import {createEntityAdapter} from '@reduxjs/toolkit';

import {EventGroup} from 'pages/event-management/utils/event-management.types';

/**
 * CRUD adapter for handling Event data within the store. Default is sorted by the start date.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const eventsAdapter = createEntityAdapter<EventGroup>({
    selectId: (event) => event.startDate,
    sortComparer: (a, b) => b.startDate.localeCompare(a.startDate),
});
